import * as React from 'react'
import { Divider, Grid } from '@mui/material'
import { formatDate } from 'date-fns'
import GridItem from 'src/components/grid-item/GridItem'
import { PersonPerfinReport } from 'src/modules/serasa/serasa.experian.person.types'

export type PefinProps = {
    pefin?: PersonPerfinReport
}

export default function Pefin({ pefin }: PefinProps) {
    return (
        <>
            <Divider textAlign="center">Pefin</Divider>
            {pefin && (
                <>
                    <Grid container spacing={1} paddingTop={2} paddingBottom={2} paddingLeft={5} paddingRight={5}>
                        <GridItem label="Total Ocorrências" value={pefin.summary.count.toFixed(0)} xs={6} />
                        <GridItem label="Total Valores" value={pefin.summary.balance.toFixed(2)} xs={6} />
                    </Grid>

                    {pefin.pefinResponse?.map((ocorrencia, index) => (
                        <div key={index}>
                            <Divider textAlign="center">Ocorrência {index + 1}</Divider>

                            <Grid key={ocorrencia.cadus} container spacing={1}>
                                <GridItem
                                    label="Data"
                                    value={formatDate(ocorrencia.occurrenceDate, 'dd/MM/yyyy')}
                                    xs={6}
                                />
                                <GridItem label="Modalidade" value={ocorrencia.legalNature} xs={6} />
                                <GridItem label="Valor" value={ocorrencia.amount.toFixed(2)} xs={6} />
                                <GridItem label="Contrato" value={ocorrencia.contractId} xs={6} />
                                <GridItem label="Origem" value={ocorrencia.creditorName || '-'} xs={6} />
                            </Grid>
                        </div>
                    ))}
                </>
            )}
        </>
    )
}
